import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const WallGraphics = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for wall graphics?", 
            answer: "Printingy offers extensive customisation options for wall graphics printing, including sizes, materials, and finishes. Our services include wall painting designs and tailored colour combinations to suit your personal or brand style. From abstract designs to intricate patterns, we create graphics that align with your vision and purpose."
        },
        { 
            question: "Does Printingy handle bulk orders for wall graphics?", 
            answer: "Yes, Printingy specialises in bulk wall graphics printing, catering to large-scale projects for businesses and homes. Bulk printing ensures consistent quality and cost-effective solutions, making it ideal for office branding, retail spaces, or home makeovers. Our efficient production processes guarantee reliable and timely delivery for all bulk orders."
        },
        { 
            question: "What industries benefit from wall graphics printing services?", 
            answer: "Wall graphics printing services are widely used in retail, hospitality, corporate offices, and residential spaces. Businesses rely on wall graphics printing for branding, while homeowners and interior designers use our services for wall painting ideas at home. Printingy provides tailored solutions to meet the unique needs of each sector."
        },
        { 
            question: "What materials and finishes are available for wall graphics?", 
            answer: "We use high-quality materials for wall graphics printing, including vinyl, fabric, and eco-friendly options. Matte, glossy, and textured finishes add durability and aesthetic appeal. These materials ensure your wall graphics maintain a professional appearance and withstand wear and tear in residential and commercial spaces."
        },
        { 
            question: "Does Printingy provide design assistance for wall graphics?", 
            answer: "Yes, our wall graphics printing services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to create visually engaging and functional layouts. From colour selection to custom patterns, we ensure your wall graphics reflect your style and goals."
        },
        { 
            question: "What is the typical turnaround time for wall graphics printing?", 
            answer: "Turnaround times for wall graphics printing depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
        },
        { 
            question: "Are eco-friendly options available for wall graphics printing?", 
            answer: "Printingy is committed to sustainability and offers eco-friendly options for wall painting designs and graphics. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for businesses and homeowners seeking environmentally responsible solutions."
        },
        { 
            question: "What factors should I consider when ordering wall graphics?", 
            answer: "Consider the purpose, placement, and audience when ordering wall graphics printing. Choosing the right material, size, and design elements ensures your graphics are effective and visually appealing. Printingy’s team guides the process to help you create products that achieve your goals."
        },
        { 
            question: "How do I place an order for wall graphics printing?", 
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for wall graphics printing, including customisation options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
        },
        { 
            question: "What makes bulk wall graphics printing cost-effective?", 
            answer: "Bulk wall graphics printing reduces per-unit costs, making it an economical choice for large-scale projects. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk wall graphics printing services ensure exceptional value while maintaining professional standards."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Wall Graphics');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes



  return (
    <div>
    <MetaManager 
  title="Custom Wall Graphics and Painting Designs Printing Services"
  description="Professional wall graphics printing for homes and businesses. Bulk custom wall painting designs, colour combinations, and painting ideas for impactful spaces."
  keywords="Wall Graphics,
Wall graphics printing,
Wall painting ideas at home,
Wall Painting Designs,
Wall Colour Combination & Painting Ideas

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Custom Wall Graphics Printing Services</h1>
              <h2 className="text-muted">Professional wall painting designs and graphics for homes and businesses</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Wall graphics are an innovative and impactful way to transform spaces at home or in commercial settings. Printingy specialises in wall graphics printing, offering customised solutions that include wall painting designs, colour combinations, and unique graphic ideas to enhance any environment.</p>
          <p>Our services cater to diverse needs, from creative wall painting ideas at home to professional branding for businesses. We provide durable and vibrant prints for indoor and outdoor walls, ensuring long-lasting impressions. With bulk printing options and advanced printing technology, we deliver high-quality wall colour combinations and painting ideas tailored to your style and vision.</p>
          <p>Trust Printingy for reliable and cost-effective wall graphic solutions that bring creativity and functionality to your spaces.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Wall Graphics Printing Solutions</h2>
                <h3 className="large-hed">High-quality, customisable, and affordable wall graphics and painting designs</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Customised wall graphics printing for unique home and office spaces.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Creative wall painting designs and colour combination ideas.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials for long-lasting indoor and outdoor use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing solutions for cost-effective large-scale projects.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for vibrant colours and sharp details.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials and non-toxic printing practices.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by homeowners, interior designers, and corporate businesses nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/wallgraphics.jpg" // Path relative to the public folder
                  alt="Bulk printing of wall colour combinations and graphics"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Wall Graphics Delivered On Time</h2>
            <h3 className="small-hed">Focus on your vision while we handle your wall graphics printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with expert craftsmanship to deliver exceptional wall graphics printing services. We ensure precision and consistency in every print, whether for wall painting designs at home or branded graphics for office walls.</p>
            <p>Our streamlined processes guarantee timely delivery, even for bulk orders. Partner with Printingy for professional wall graphics and designs that enhance your spaces and captivate your audience.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default WallGraphics;
